import React from 'react';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import ErrorBoundary from './ErrorBoundary';
import db from './db';

// CradlepointRouterTable component
export default class CradlepointRouterTable extends React.Component {

    // constructor
    constructor(props) {
        super(props);  
        this.state={
            cradelpointRouter:{}
            , cradelpointNetDevices:[]
        };

    }
    componentDidMount(prevProps) {
        if(this.props.cradlepointSerialNumber){
            let qry = this.props.securityObject.httpServer
                        + "api/get/cradlepointRouter?serial_number="
                        + this.props.cradlepointSerialNumber;
            db.getSearchPopupData( 
                qry
                ,this.props.securityObject
                ,(list) => { 
                    let cradelpointRouter={};
                    if(list.length>0){
                        cradelpointRouter=list[0];
                    }
                    this.setState({
                        cradelpointRouter : cradelpointRouter
                    })

                    // get cradelpointNetDevices
                    let qry2 = this.props.securityObject.httpServer
                    + "api/get/cradlepointNetDevices?router_id="
                    + cradelpointRouter.id;
                    db.getSearchPopupData( 
                        qry2
                        ,this.props.securityObject
                        ,(list2) => { 
                            this.setState({
                                cradelpointNetDevices : list2
                            })
                        }
                    )  
                }
            )                

        }  
    }
    // render
    render() {

        return (true)?(
            <div className='relative-div'>
                Cradlepoint:<br />
                <table border="1">
                    <tbody>
                    <tr>
                        <td className='plain'>Serial Number:</td>
                        <td className='plain'>{this.state.cradelpointRouter.serial_number}</td>
                        <td className='plain'>Asset Id:</td>
                        <td className='plain'>{this.state.cradelpointRouter.asset_id}</td>
                    </tr>
                    <tr>
                        <td className='plain'>mac Address:</td>
                        <td className='plain'>{this.state.cradelpointRouter.mac}</td>
                        <td className='plain'>IP Address:</td>
                        <td className='plain'>{this.state.cradelpointRouter.ipv4_address}</td>
                    </tr>
                    <tr>
                        <td className='plain'>Product:</td>
                        <td className='plain'>{this.state.cradelpointRouter.full_product_name}</td>
                        <td className='plain'>As Of:</td>
                        <td className='plain'>{this.state.cradelpointRouter.last_updated_time}</td>
                    </tr>
                    <tr>
                        <td className='plain'>id:</td>
                        <td className='plain'>{this.state.cradelpointRouter.id}</td>
                        <td className='plain'></td>
                        <td className='plain'></td>
                    </tr>                      
                    <tr>
                        <td colSpan={4}>
                        <TableScrollbar height="200px">
                            <ErrorBoundary>
                                <Table columns={[
                                            {title:"Status", key:"summary", width:10}
                                            ,{title: 'service_type', key: 'service_type', width :10 }
                                            ,{title: 'info', key: 'ssid', width :30, render:this.renderNetDeviceInfo }
                                        ]} dataSource={this.state.cradelpointNetDevices} />
                            </ErrorBoundary>
                        </TableScrollbar>
                        </td>
                    </tr>  
                    </tbody>                                    
                </table>
            </div>
        ):"";
    }
    renderNetDeviceInfo(cellData, rowData, rowIndex){
        let data='';
        if(rowData.ssid){
            data+='ssid:'+rowData.ssid;
        }
        if(rowData.imei){
            data+='imei:'+rowData.imei
                +"\niccid:"+rowData.iccid
                +"\nimsi:"+rowData.imsi
                ;
        }        
        let array=[];
        let btnPlus=React.createElement(
            'pre'
            ,{"key":`cpPre`}
            ,data);
        array.push(btnPlus);
        // return div
        let div=React.createElement('div',{"key":`cpDiv`}, array );
        return div;    
    }
}

